import React, { useState, useEffect } from "react";
import { Toggle } from "components/Elements/Toggle/Toggle.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import config from "config";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { contains_heb } from "utils/hebrewOrArabicText.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";

const FooterLinksConteiner = ({
  linkFooters,
  setLinkFooters,
  setEditCustomFooterLinks,
  setDisplayFooterLinks,
  displayFooterLinks,
  footerAbout,
  footerSupport,
  footerTerms,
  setUpdateBeforeSave,
}) => {
  const { addToast } = useToasts();
  const { isPremium } = useUser();
  const { setModal } = useModal();
  const { getTextByKey, getDirection, getPath } = useContent();
  const [title1, setTitle1] = useState("");
  const [title2, setTitle2] = useState("");
  const [title3, setTitle3] = useState("");
  const [link1, setLink1] = useState("");
  const [link2, setLink2] = useState("");
  const [link3, setLink3] = useState("");

  const defaultAboutLink = config.baseurl + getPath() + "jumbo-forms";
  const defaultSupportLink = config.baseurl + getPath() + "support/jumbo-embed";
  const defaultTermsLink = config.baseurl + getPath() + "terms";
  const [updateFooterApi, setUpdateFooterApi] = useState(false);
  const [showFooters, setShowFooters] = useState(displayFooterLinks);

  const [footerChanges, setFooterChanges] = useState(false);
  useEffect(() => {
    if (linkFooters) {
      if (linkFooters.length > 0) {
        setTitle1(linkFooters[0].FooterLinkTitle);
        setLink1(linkFooters[0].FooterLinkUrl);
      }
      if (linkFooters.length > 1) {
        setTitle2(linkFooters[1].FooterLinkTitle);
        setLink2(linkFooters[1].FooterLinkUrl);
      }
      if (linkFooters.length > 2) {
        setTitle3(linkFooters[2].FooterLinkTitle);
        setLink3(linkFooters[2].FooterLinkUrl);
      }
    }
  }, []);

  const HandleChange = (e, type, num) => {
    if (isPremium()) {
      switch (type) {
        case "link":
          switch (num) {
            case 1:
              setLink1(e);
              break;
            case 2:
              setLink2(e);
              break;
            case 3:
              setLink3(e);
              break;

            default:
              break;
          }
          break;
        case "title":
          switch (num) {
            case 1:
              setTitle1(e);
              break;
            case 2:
              setTitle2(e);
              break;
            case 3:
              setTitle3(e);
              break;

            default:
              break;
          }
          break;

        default:
          break;
      }
      setFooterChanges(true);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    let temp = [];
    let isCustom = false;
    if (title1 === "" && link1 === "") {
    } else {
      temp.push({ FooterLinkTitle: title1, FooterLinkUrl: link1 });
      if (
        title1.toLowerCase().trim() !== footerAbout.toLowerCase().trim() ||
        link1.toLowerCase().trim() !== defaultAboutLink.toLowerCase().trim()
      ) {
        isCustom = true;
      }
    }
    if (title2 === "" && link2 === "") {
    } else {
      temp.push({ FooterLinkTitle: title2, FooterLinkUrl: link2 });
      if (
        title2.toLowerCase().trim() !== footerSupport.toLowerCase().trim() ||
        link2.toLowerCase().trim() !== defaultSupportLink.toLowerCase().trim()
      ) {
        isCustom = true;
      }
    }
    if (title3 === "" && link3 === "") {
    } else {
      temp.push({ FooterLinkTitle: title3, FooterLinkUrl: link3 });
      if (
        title3.toLowerCase().trim() !== footerTerms.toLowerCase().trim() ||
        link3.toLowerCase().trim() !== defaultTermsLink.toLowerCase().trim()
      ) {
        isCustom = true;
      }
    }
    if (temp.length > 0) {
      setEditCustomFooterLinks(isCustom);
      setLinkFooters(temp);
    }
  }, [title1, link1, title2, link2, title3, link3]);

  const handleToggleDisplayFooter = () => {
    if (isPremium()) {
      setDisplayFooterLinks((prev) => !prev);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    if (displayFooterLinks !== showFooters) {
      setShowFooters(displayFooterLinks);
      setUpdateFooterApi(true);
    }
  }, [showFooters, displayFooterLinks]);

  useEffect(() => {
    if (updateFooterApi) {
      setUpdateBeforeSave({
        mode: true,
        action: "updateFooter",
        heightChanged: true,
      });
      setUpdateFooterApi(false);
    }
  }, [updateFooterApi]);

  //Title1
  const [focusTitle1, setFocusTitle1] = useState(null);
  const [blurTitle1, setBlurTitle1] = useState(null);
  useEffect(() => {
    if (blurTitle1 !== focusTitle1) {
      setUpdateFooterApi(true);
    }
  }, [blurTitle1]);

  //Link1
  const [focusLink1, setFocusLink1] = useState(null);
  const [blurLink1, setBlurLink1] = useState(null);
  useEffect(() => {
    if (blurLink1 !== focusLink1) {
      setUpdateFooterApi(true);
    }
  }, [blurLink1]);
  //Title2
  const [focusTitle2, setFocusTitle2] = useState(null);
  const [blurTitle2, setBlurTitle2] = useState(null);
  useEffect(() => {
    if (blurTitle2 !== focusTitle2) {
      setUpdateFooterApi(true);
    }
  }, [blurTitle2]);
  //Link2
  const [focusLink2, setFocusLink2] = useState(null);
  const [blurLink2, setBlurLink2] = useState(null);
  useEffect(() => {
    if (blurLink2 !== focusLink2) {
      setUpdateFooterApi(true);
    }
  }, [blurLink2]);
  //Title3
  const [focusTitle3, setFocusTitle3] = useState(null);
  const [blurTitle3, setBlurTitle3] = useState(null);
  useEffect(() => {
    if (blurTitle3 !== focusTitle3) {
      setUpdateFooterApi(true);
    }
  }, [blurTitle3]);
  //Link3
  const [focusLink3, setFocusLink3] = useState(null);
  const [blurLink3, setBlurLink3] = useState(null);
  useEffect(() => {
    if (blurLink3 !== focusLink3) {
      setUpdateFooterApi(true);
    }
  }, [blurLink3]);

  return (
    <div className="edit-footer-links-container">
      <div className="title">{getTextByKey("edit-footer-links-title")}</div>
      <div className="links-alert">
        <span>{getTextByKey("footer-links-embedpage-text")}</span>
      </div>
      <div className="actions">
        <div className="toogle">
          <Toggle
            status={isPremium() ? displayFooterLinks : true}
            setStatus={handleToggleDisplayFooter}
          />
          <span>{getTextByKey("display-footer-links")}</span>
        </div>
      </div>
      <div
        className={`links ${
          displayFooterLinks ? "enable-links" : "disable-links"
        }`}
      >
        <div className="set-links">
          <div className="title-link div-section">
            <span>{getTextByKey("edit-footer-title")}</span>
            <input
              style={{
                direction: contains_heb(title1),
              }}
              value={title1}
              onChange={(e) => HandleChange(e.target.value, "title", 1)}
              onFocus={(e) => setFocusTitle1(e.target.value)}
              onBlur={(e) => setBlurTitle1(e.target.value)}
              type="text"
            />
          </div>
          <div className="url-link div-section">
            <span>{getTextByKey("edit-footer-link")}</span>
            <input
              value={link1}
              onChange={(e) => HandleChange(e.target.value, "link", 1)}
              onFocus={(e) => setFocusLink1(e.target.value)}
              onBlur={(e) => setBlurLink1(e.target.value)}
              type="text"
            />
          </div>
        </div>
        <div className="set-links">
          <div className="title-link div-section">
            <span>{getTextByKey("edit-footer-title")}</span>
            <input
              style={{
                direction: contains_heb(title2),
              }}
              value={title2}
              onChange={(e) => HandleChange(e.target.value, "title", 2)}
              onFocus={(e) => setFocusTitle2(e.target.value)}
              onBlur={(e) => setBlurTitle2(e.target.value)}
              type="text"
            />
          </div>
          <div className="url-link div-section">
            <span>{getTextByKey("edit-footer-link")}</span>
            <input
              value={link2}
              onChange={(e) => HandleChange(e.target.value, "link", 2)}
              onFocus={(e) => setFocusLink2(e.target.value)}
              onBlur={(e) => setBlurLink2(e.target.value)}
              type="text"
            />
          </div>
        </div>
        <div className="set-links">
          <div className="title-link div-section">
            <span>{getTextByKey("edit-footer-title")}</span>
            <input
              style={{
                direction: contains_heb(title3),
              }}
              value={title3}
              onChange={(e) => HandleChange(e.target.value, "title", 3)}
              onFocus={(e) => setFocusTitle3(e.target.value)}
              onBlur={(e) => setBlurTitle3(e.target.value)}
              type="text"
            />
          </div>
          <div className="url-link div-section">
            <span>{getTextByKey("edit-footer-link")}</span>
            <input
              value={link3}
              onChange={(e) => HandleChange(e.target.value, "link", 3)}
              onFocus={(e) => setFocusLink3(e.target.value)}
              onBlur={(e) => setBlurLink3(e.target.value)}
              type="text"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterLinksConteiner;
